export const MAX_COLUMNS = 12;
export const MIN_COL_SPAN = 1;
export const MAX_CELLS = 6;
export const MAX_VERTICAL_MARGIN = 250;

export const LAYOUT_DEFAULTS = {
  backgroundColor: null,
  backgroundImage: null,
  borderColor: null,
  borderWidth: 0,
  borderRadius: 0,
  backdropColor: null,
  backdropImage: null,
  backdropPaddingTop: 0,
  backdropPaddingBottom: 0,
  gap: 20,
  cellPadding: [18, 0, 18, 0],
  cellVerticalAlignment: 'TOP',
  responsivenessBehaviour: 'STACK',
  responsivenessBreakpoint: 440,
  designTarget: 'LAYOUT',
  banner: null,
} as const;

export const normalizePadding = (padding: number[] | undefined, defaults: number[]) => {
  if (!padding || padding.length === 0) {
    return defaults;
  }

  if (padding.length === 1) {
    return [padding[0], padding[0], padding[0], padding[0]];
  }

  if (padding.length === 2) {
    return [padding[0], padding[1], padding[0], padding[1]];
  }

  if (padding.length === 3) {
    return [padding[0], padding[1], padding[2], padding[1]];
  }

  return padding;
};
